import { h } from 'vue';
// @ts-ignore
import { BTableColumn } from 'buefy/dist/esm/table';
// @ts-ignore
import { VNodeData } from 'vue/types/vnode.d';

export interface TableColumnProps {
  field?: string;
  label?: string;
  width?: string;
  numeric?: boolean;
  sortable?: boolean;
  customKey?: string;
  clickable?: boolean;
  cellClass?: string;
  headerClass?: string;
}

export function column(
  props: TableColumnProps,
  scopedSlots: VNodeData['scopedSlots'] = {},
) {
  return h(BTableColumn, {
    props,
    scopedSlots,
  });
}

const COLUMN_WIDTH = '180px';

export function numericColumn(props: TableColumnProps, scopedSlots: VNodeData['scopedSlots']) {
  return h(BTableColumn, {
    scopedSlots,
    props: {
      ...props,
      numeric: true,
      width: COLUMN_WIDTH,
    },
  });
}

export function textColumn(
  props: TableColumnProps,
  scopedSlots: VNodeData['scopedSlots'] = {},
) {
  return h(BTableColumn, {
    scopedSlots,
    class: props.cellClass ?? '',
    props: {
      ...props,
      width: COLUMN_WIDTH,
    },
  });
}

export function sortableNumericColumn(props: TableColumnProps, scopedSlots: VNodeData['scopedSlots']) {
  return numericColumn({
    ...props,
    sortable: true,
  }, scopedSlots);
}

export function sortableTextColumn(props: TableColumnProps, scopedSlots: VNodeData['scopedSlots'] = {}) {
  return textColumn({
    ...props,
    sortable: true,
  }, scopedSlots);
}

export function tagColumn(props: TableColumnProps, scopedSlots: VNodeData['scopedSlots']) {
  return h(BTableColumn, {
    scopedSlots,
    props: {
      ...props,
      width: props.width ?? '300px',
    },
  });
}
